import * as vp from 'vopay';
import { useEffect, FunctionComponent, useState } from 'react';
import { useParams } from 'react-router-dom';
import InteracMoneyRequestTransactionInfo from './InteracMoneyRequestTransactionInfo';
import useFetchInteracMoneyRequestTransaction from '../../hooks/useApi/useFetchInteracMoneyRequestTransaction';
import useAccountBearer from '@/hooks/useApi/useAccountBearer';

type FC = FunctionComponent<vp.TransactionIdAndType>;

const InteracMoneyRequestTransactionContainer: FC = (props: vp.TransactionIdAndType) => {
  const { TransactionID, Type } = props;
  const { accountId } = useParams<{ accountId: string }>();
  const token = useAccountBearer(accountId);
  const [InteracMoneyRequest, getInteracMoneyRequestTransaction] = useFetchInteracMoneyRequestTransaction({
    bearer: token,
  });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<vp.InteracTransactionResponse>();

  useEffect(() => {
    if (!token) return;
    if (Type === vp.TransactionType.INTERACT_MONEY_REQUEST) {
      getInteracMoneyRequestTransaction(TransactionID);
    }
  }, [currentTransactionId, token]);

  useEffect(() => {
    if (InteracMoneyRequest) {
      setTransaction(InteracMoneyRequest);
    }
  }, [InteracMoneyRequest]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return <div>{transaction && <InteracMoneyRequestTransactionInfo transaction={transaction} />}</div>;
};

export default InteracMoneyRequestTransactionContainer;
